import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import ChangePasswordCard from "./ChangePasswordCard";

const GROUPS = [
    {
        name: "Contactos institucionais",
        fields: [
            { k: "phone", l: "Telefone" },
            { k: "whatsapp", l: "WhatsApp (só dígitos, com 351)" },
            { k: "email", l: "Email" },
            { k: "coverage_area", l: "Área de atuação" },
            { k: "hours", l: "Horário" },
        ],
    },
    {
        name: "Redes sociais e empresa",
        fields: [
            { k: "social_facebook", l: "Facebook (URL)" },
            { k: "social_instagram", l: "Instagram (URL)" },
            { k: "company_nif", l: "NIF (opcional)" },
            { k: "company_address", l: "Morada (opcional)" },
        ],
    },
    {
        name: "Homepage — Hero",
        fields: [
            { k: "hero_headline", l: "Headline principal" },
            { k: "hero_subheadline", l: "Subheadline", area: true },
        ],
    },
    {
        name: "Verificação de motores de pesquisa",
        help: "Cole aqui apenas o conteúdo do atributo content=\"…\" da meta tag que o Google/Bing lhe fornecem. A verificação é injetada automaticamente no <head> do site.",
        fields: [
            { k: "google_site_verification", l: "Google Search Console (content)", placeholder: "abc123XYZ_only-the-content-value" },
            { k: "bing_site_verification", l: "Bing Webmaster Tools (content)", placeholder: "abc123XYZ_only-the-content-value" },
            { k: "ga_measurement_id", l: "Google Analytics 4 — Measurement ID", placeholder: "G-XXXXXXXXXX" },
        ],
    },
];

export default function AdminSettings() {
    const [form, setForm] = useState({});
    useEffect(() => { api.get("/admin/settings").then(r => setForm(r.data)); }, []);

    const save = async () => {
        try { await api.put("/admin/settings", form); toast.success("Definições guardadas"); }
        catch { toast.error("Erro ao guardar"); }
    };

    return (
        <div className="max-w-2xl">
            <h1 className="font-display text-3xl font-bold text-stone-900 mb-6">Definições</h1>
            <p className="text-sm text-emerald-900 bg-emerald-50 border border-emerald-200 rounded p-4 mb-4">
                As <b>imagens de cada secção do site</b> agora são editadas em <b>Conteúdos</b> (para ficarem junto dos textos correspondentes).
            </p>
            <div className="space-y-6">
                {GROUPS.map(g => (
                    <div key={g.name} className="bg-white rounded-xl border border-stone-200 p-6">
                        <h2 className="font-display font-bold text-lg mb-2">{g.name}</h2>
                        {g.help && <p className="text-sm text-stone-500 mb-4">{g.help}</p>}
                        <div className="space-y-3">
                            {g.fields.map(f => (
                                <label key={f.k} className="block">
                                    <span className="text-xs uppercase tracking-wider text-stone-500 block mb-1">{f.l}</span>
                                    {f.area
                                        ? <textarea rows={3} value={form[f.k] || ""} onChange={(e) => setForm({...form, [f.k]: e.target.value})} className="w-full border border-stone-300 rounded p-2 text-sm" />
                                        : <input value={form[f.k] || ""} onChange={(e) => setForm({...form, [f.k]: e.target.value})} placeholder={f.placeholder || ""} className="w-full border border-stone-300 rounded p-2 text-sm font-mono" data-testid={`settings-${f.k}`} />
                                    }
                                </label>
                            ))}
                        </div>
                    </div>
                ))}
                <button onClick={save} className="btn-copper !py-2 !px-4 text-sm" data-testid="admin-settings-save">Guardar alterações</button>

                <ChangePasswordCard />
            </div>
        </div>
    );
}
